// extracted by mini-css-extract-plugin
export default {"clearIconWrapper":"SUaFOCe0ZZA9EdkeCtj8","wrapper":"Vk4CjaHP34OJFk1Pv8M2"};